import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { Component as BrComponent, Page } from '@bloomreach/spa-sdk/';
import { Logger } from '@utils/logger';
import { DropdownItem } from '@frk/eds-components';
import { generateUUID } from '@utils/text/string-utils';
import { EMAIL_VALIDATOR } from '@utils/app.constants';

interface CustomFormField {
  validationRuleId?: string;
  regExp?: string | RegExp;
  values: any;
  type: string;
  invalid: boolean;
  invalidText: string;
  id?: string;
}

interface GroupItems {
  id?: string;
  label?: string;
}
/**
 * Logger
 */
const logger = Logger.getLogger('CustomFormComponent');

/**
 * The Custom Form component
 *
 * Selector: `ft-custom-form`
 *
 * Exported as: `CustomFormComponent`
 */
@Component({
  selector: 'ft-custom-form',
  templateUrl: './custom-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomFormComponent implements OnInit {
  /**
   * The Bloomreach component
   */
  @Input() component!: BrComponent;

  /**
   * The Bloomreach page
   */
  @Input() page!: Page;

  content: any;
  document: any;
  items: DropdownItem[] = [];
  radioItems: GroupItems[] = [];
  checkItems: GroupItems[] = [];
  fields: CustomFormField[] = [];

  /**
   * Constructor
   */
  constructor() {}

  /**
   * On initialisation
   */
  ngOnInit() {
    this.document = this.getDocument();
    this.content = this.getContent();
    this.fields = this.content?.pageBeans[0]?.fieldBeans.map((fieldBean) => {
      return {
        ...fieldBean,
        invalid: false,
        invalidText: '',
        id: `field_${generateUUID()}`,
      };
    });

    this.fields?.forEach((item) => {
      if (item.type === 'DROPDOWN') {
        for (let i = 0; i < item.values.length; i++) {
          this.items.push({ value: item.id + i, label: item.values[i] });
        }
      }
      if (item.type === 'RADIOGROUP') {
        for (let i = 0; i < item.values.length; i++) {
          this.radioItems.push({ id: item.id + i, label: item.values[i] });
        }
      }
      if (item.type === 'CHECKBOXGROUP') {
        for (let i = 0; i < item.values.length; i++) {
          this.checkItems.push({ id: item.id + i, label: item.values[i] });
        }
      }
    });
  }

  /**
   * Read the content from the document
   */
  getContent() {
    return this.document?.getData();
  }

  /**
   * Read document
   */
  getDocument() {
    const document = this.component.getModels<DocumentModels>().formDocument;
    return document && this.page.getContent(document);
  }
  onRadioChange(event: MouseEvent): void {}

  onInputTextChange(event: string, fieldBean: CustomFormField) {
    const reg: RegExp = new RegExp(fieldBean.regExp);
    const emailReg: RegExp = new RegExp(EMAIL_VALIDATOR);
    if (fieldBean.type === 'TEXT_FIELD' && fieldBean.regExp !== '') {
      if (!reg.test(event)) {
        fieldBean.invalid = true;
        fieldBean.invalidText = 'Please enter only Alphabets';
      } else {
        fieldBean.invalid = false;
        fieldBean.invalidText = '';
      }
    }
    if (
      fieldBean.type === 'TEXT_FIELD' &&
      fieldBean.validationRuleId === 'email'
    ) {
      if (!emailReg.test(event)) {
        fieldBean.invalid = true;
        fieldBean.invalidText = 'Email address is not valid';
      } else {
        fieldBean.invalid = false;
        fieldBean.invalidText = '';
      }
    }
  }
}
